module.exports = __webpack_public_path__ + "img/download_icon.7d162245.svg";